import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface UserDetails {
  id?: string;
  storeId?: string;
  companyId?: string;
  [key: string]: unknown;
}

export interface UserState {
  userDetails?: UserDetails;
}

export const initialUserState: UserState = {};

export const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<UserDetails>) => {
      state.userDetails = action.payload;
    },
    resetUserDetails: (state) => {
      state.userDetails = initialUserState.userDetails;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserDetails, resetUserDetails } = userSlice.actions;

export default userSlice.reducer;
